<template>
  <section class="pick-up-time-container">
    <div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div style="display: flex; width: 100%; justify-content: center; margin-right: 10px">
          <div class="pick-up-box" :class="no_time_pickup ? 'disabled-pickup-time' : ''">
            <span v-b-modal.pick-up-time :disabled="no_time_pickup" class="pick-up-time__value" style="height: 100%">
              {{ timePickup['HH'] + ':' + timePickup['mm'] }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="el-checkbox el-checkbox-green d-flex mt-1 mr-4">
            <input
              id="customCheck"
              v-model="no_time_pickup"
              type="checkbox"
              required
              name="no_time_pickup"
              value="true"
              class="form-control input-check-pax input-contact"
            />
            <label class="el-checkbox-style" for="customCheck"></label>
          </div>
          <div style="min-width: 120px; color: #474747">
            <p class="font-weight-bold">{{ pickUpTitle.NO_TIME_PICKUP ? pickUpTitle.NO_TIME_PICKUP : 'as soon as possible' }}</p>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center">
        <div class="el-checkbox el-checkbox-green d-flex mr-4">
          <input
            id="next_day"
            v-model="next_day"
            :disabled="no_time_pickup"
            type="checkbox"
            name="next_day"
            value="true"
            required
            class="form-control input-check-pax input-contact"
          />
          <label class="el-checkbox-style" for="next_day"></label>
        </div>
        <div style="min-width: 120px; color: #474747">
          <span class="font-weight-bold">{{ pickUpTitle.NEXT_DAY ? pickUpTitle.NEXT_DAY : 'Next day' }}</span>
        </div>
      </div>
      <div class="pick-up-time__modal">
        <b-modal id="pick-up-time" centered hide-footer hide-header-close hide-header>
          <PopupPickTime :time-pickup="timePickup" @confirmPickUpTime="handlePickTime" />
        </b-modal>
      </div>
    </div>
  </section>
</template>
<script>
import PopupPickTime from '@/components/PopupPickTime/index'
import Vue from 'vue'

export default {
  name: 'PickUpTime',
  components: {
    PopupPickTime
  },
  props: {
    pickUpTitle: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timePickup: {
        HH: 'HH',
        mm: 'mm'
      },
      no_time_pickup: true,
      next_day: false
    }
  },
  watch: {
    no_time_pickup() {
      this.setTimePickUp()
      if (this.no_time_pickup) {
        this.next_day = false
      }
      let data = {
        no_time_pickup: this.no_time_pickup,
        next_day: this.next_day
      }
      this.$emit('changePickUpState', data)
      if (this.no_time_pickup) {
        this.$set(this.timePickup, 'HH', 'HH')
        this.$set(this.timePickup, 'mm', 'mm')
      }
    },
    next_day() {
      if (this.next_day) {
        this.no_time_pickup = false
      }
      let data = {
        no_time_pickup: this.no_time_pickup,
        next_day: this.next_day
      }
      this.$emit('changePickUpState', data)
    }
  },
  mounted() {
    let data = {
      no_time_pickup: this.no_time_pickup,
      next_day: this.next_day
    }
    this.$emit('changePickUpState', data)
  },
  methods: {
    setTimePickUp() {
      let d = new Date(+new Date() + 60000 * 30)
      let minutes =
        d.getMinutes() / 5 === 0
          ? d.getMinutes()
          : d.getMinutes() % 10 > 5
          ? d.getMinutes() - (d.getMinutes() % 10) + 10
          : d.getMinutes() - (d.getMinutes() % 10)
      this.$set(this.timePickup, 'HH', String(d.getHours()).length === 1 ? `0${d.getHours()}` : d.getHours().toString())
      this.$set(this.timePickup, 'mm', String(minutes).length === 1 ? `0${minutes}` : minutes.toString())
      this.$emit('changePreferedTimePickUp', this.timePickup)
    },
    changeTime() {
      this.$bvModal.show('pick-up-time')
      this.$emit('changePreferedTimePickUp', this.timePickup)
    },
    handlePickTime(value) {
      this.$bvModal.hide('pick-up-time')
      this.$emit('changePreferedTimePickUp', value)
      this.$set(this.timePickup, 'HH', value['HH'] || '00')
      this.$set(this.timePickup, 'mm', value['mm'] || '00')
    }
  }
}
</script>
<style lang="scss" scoped>
.pick-up-time-container {
  background-color: #ffffff;
}
.pick-up-box {
  display: flex;
  min-width: 80%;
  justify-content: center;
  border-bottom: #7d7d7d 2px solid;
}
.pick-up-time {
  display: flex;
  align-items: center;
  &__value {
    cursor: pointer;
    --font-size: 24pt;
    border: 0 !important;
    height: var(--font-size);
    font-size: var(--font-size);
    color: var(--text-color);
    font-weight: 300;
  }
  .disabled-pickup-time {
    background-color: #e9ecef;
    opacity: 1;
    border-radius: 0.25rem;
  }
}
</style>
